import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Link,
  Flex,
} from "@chakra-ui/react";

import { AnalyticsEvents } from "@/utils/analytics-events";
import { analyticsService } from "@/utils/analytics-service";

interface TrialExpiredModalProps {
  isOpen: boolean;
  // onClose is not strictly needed if the only actions are logout/contact
}

export const TrialExpiredModal = ({ isOpen }: TrialExpiredModalProps) => {
  const handleClose = () => {};

  return (
    <Modal
      closeOnEsc={false}
      closeOnOverlayClick={false} // Use dummy handler
      isCentered
      isOpen={isOpen} // Prevent closing on overlay click
      onClose={handleClose} // Prevent closing with Esc key
    >
      <ModalOverlay />
      <ModalContent className="!max-w-lg !rounded">
        <ModalHeader className="!mx-4 text-xl font-semibold text-gray-900">
          Trial Period Ended
        </ModalHeader>
        <ModalBody className="pb-4 !px-4">
          <Text className="text-gray-800">
            Your trial period has ended. To extend your access or learn more
            about our plans, please contact our sales team.
          </Text>
        </ModalBody>

        <ModalFooter className="!pt-2 !px-4">
          <Flex className="w-full justify-end">
            <Link href="mailto:sales@clootrack.com" isExternal>
              <Button
                colorScheme="secondary"
                onClick={() => {
                  analyticsService.trackEvent(
                    AnalyticsEvents.CONTACT_US.UNLOCK_APP
                  );
                }}
                size="sm"
              >
                Contact Sales team
              </Button>
            </Link>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
